export { default as useTimeout } from './useTimeout';
export * from './useTimeout';
//# sourceMappingURL=index.js.map